// extracted by mini-css-extract-plugin
export var statusBar = "CartStatusBar-module--statusBar--D+OAH";
export var clearCart = "CartStatusBar-module--clearCart--i9W32";